<template>
	<div class="xiao-main background-white">
		<input class="file" name="file" type="file"
			accept=".csv, application/vnd.openxmlformats-officedocument.spreadsheetml.sheet, application/vnd.ms-excel"
			@change="update" ref="file2" id="file-excel" />
		<div class="xiao-main-title">
			<div class="top-line"></div>
			监控设置
		</div>
		<div class="xiao-main-top">

			<div class="top-line"></div>
			<div>
				<div>监控名称:</div>
				<el-input placeholder="请输入内容" v-model="deviceName" clearable>
				</el-input>
			</div>

			<div class="top-line"></div>
			<div>
				<div class="zhanwei">小区级别:</div>
				<el-button type="primary" icon="el-icon-search" @click="showBtn(1)">查询</el-button>
			</div>
			<div class="top-line"></div>
			<div>
				<div class="zhanwei">小区级别:</div>
				<el-button @click="showBtn(3)">更新数据</el-button>
			</div>
			<!-- <div class="top-line"></div>
			<div>
				<div class="zhanwei">小区级别:</div>
				<!-- <el-button >刷新</el-button> -->
			<!-- <el-button type="primary" @click="uploadImg">上传excel<i class="el-icon-upload el-icon--right"></i>
				</el-button> -->
			<!-- </div> -->
		</div>
		<div class="xiao-main-line"></div>
		<el-table :data="tableData" border fit max-height="600" :row-style="{height: '60px'}"
			:cell-style="{padding: '0'}">
			<el-table-column fixed type="index" label="ID" min-width="120">
			</el-table-column>
			<el-table-column prop="deviceSerial" label="监控编号" min-width="120">
			</el-table-column>
			<el-table-column prop="channelNo" label="通道" min-width="120">
			</el-table-column>
			<el-table-column prop="channelName" label="摄像头名称" min-width="120">
			</el-table-column>
			<el-table-column label="场景照片" min-width="80">
				<template slot-scope="scope">
					<el-image style="width: 100px; height: 100px" :src="scope.row.picUrl"></el-image>
				</template>
			</el-table-column>
			<el-table-column fixed="right" label="操作" min-width="120">
				<template slot-scope="scope">

					<el-button @click="selectCamera(scope.row)" type="text" size="small" v-if="scope.row.sId==0">选择
					</el-button>
					<el-button @click="quCamera(scope.row)" type="text" size="small" v-else>取消</el-button>

					<!-- <el-button @click="deleteOrderItem(scope.row)" type="text" size="small">删除</el-button> -->
				</template>
			</el-table-column>
		</el-table>
		<el-pagination @size-change="handleSizeChange" @current-change="handleCurrentChange" :current-page="page"
			:page-size="position" layout="total, prev, pager, next, jumper" :total="total">
		</el-pagination>


		<el-dialog title="添加流水" :visible.sync="tzDialogFormVisible" @close="tzDialogClose" :destroy-on-close="true">
			<el-form ref="form" :model="form" label-width="80px" label-position="top" :rules="rules">
				<el-form-item label="姓名" prop="name">
					<el-input v-model="form.name"></el-input>
				</el-form-item>
				<el-form-item label="身份证号" prop="shenfen">
					<el-input v-model="form.shenfen"></el-input>
				</el-form-item>

				<el-form-item>
					<el-button type="primary" @click="onSubmit('form')">立即创建</el-button>
					<el-button @click="tzDialogFormVisible = false">取消</el-button>
				</el-form-item>
			</el-form>
		</el-dialog>

		<el-dialog title="选择" :visible.sync="dialogVisible" width="30%" :before-close="handleClose">
			<span>确定要选择这台设备吗?</span>
			<span slot="footer" class="dialog-footer">
				<el-button @click="dialogVisible = false">取 消</el-button>
				<el-button type="primary" @click="selectCameraTo">确 定</el-button>
			</span>
		</el-dialog>

		<el-dialog title="取消" :visible.sync="quDialog" width="30%" :before-close="handleClose">
			<span>确定要取消这台设备吗?</span>
			<span slot="footer" class="dialog-footer">
				<el-button @click="quDialog = false">取 消</el-button>
				<el-button type="primary" @click="quCameraTo">确 定</el-button>
			</span>
		</el-dialog>

		<el-dialog title="确定要更新数据吗？" :visible.sync="yanDialog" @close="yanDialogClose" :destroy-on-close="true">
			<el-form ref="form" :model="yanForm" label-width="80px" label-position="top" :rules="yanRules">
				<el-form-item label="验证密码" prop="yanpass">
					<el-input v-model="yanForm.yanpass"></el-input>
				</el-form-item>
				<el-form-item>
					<el-button type="primary" @click="yanSubmit('form')">确定</el-button>
					<el-button @click="yanDialog = false">取消</el-button>
				</el-form-item>
			</el-form>
		</el-dialog>
	</div>
</template>

<script>
	export default {
		name: "jiankongset",

		data() {
			return {
				deviceName:'',
				quDialog: false,
				yanForm: {},
				yanRules: {
					yanpass: [{
						required: true,
						message: '请输验证密码',
						trigger: 'change'
					}]
				},
				rules: {
					name: [{
						required: true,
						message: '请输入姓名',
						trigger: 'change'
					}],
					shenfen: [{
						required: true,
						message: '请输入身份证号',
						trigger: 'change'
					}]
				},
				yanDialog: false,
				form: {},
				deviceInfo: {},
				tableData: [],
				jFullName: '',
				page: 1,
				position: 5,
				total: 0,
				tzDialogFormVisible: false,
				drawer: false,
				direction: 'rtl',
				labelType: '0',
				options: [{
					value: '0',
					label: '全部'
				}, {
					value: '1',
					label: '已恢复'
				}],
				delId: "",
				dialogVisible: false,
				cameraBean: {}
			}
		},
		methods: {
			quCamera(e) {
				this.cameraBean = e;
				this.quDialog = true;
			},
			selectCamera(e) {
				this.cameraBean = e;
				this.dialogVisible = true;
			},
			handleClose() {
				this.cameraBean = {};
			},
			selectCameraTo() {
				let that = this;
				const loading = this.$loading({
					lock: true,
					text: '正在提交…',
					spinner: 'el-icon-loading',
					background: 'rgba(0, 0, 0, 0.7)'
				});
				that.$axios({
					method: 'post',
					url: '/camer/selectCarmera',
					data: {
						sDeviceSerial: that.cameraBean.deviceSerial
					}
				}).then(function(respose) {
					loading.close();
					if (respose.code == "1") {
						that.dialogVisible = false;
						that.cameraBean.sId = "-1";
						that.cameraBean.sDeviceSerial = that.cameraBean.deviceSerial;
						that.$message("选择成功");
					}
				}).catch(function(error) {
					loading.close();
					console.log("--------++++++++————————————");
					console.log(error);
				});
			},
			quCameraTo() {
				let that = this;
				const loading = this.$loading({
					lock: true,
					text: '正在提交…',
					spinner: 'el-icon-loading',
					background: 'rgba(0, 0, 0, 0.7)'
				});
				that.$axios({
					method: 'post',
					url: '/camer/deleteSelectCamera',
					data: {
						sDeviceSerial: that.cameraBean.deviceSerial
					}
				}).then(function(respose) {
					loading.close();
					if (respose.code == "1") {
						that.quDialog = false;
						that.cameraBean.sId = "0";
						that.cameraBean.sDeviceSerial = "";
						that.$message("取消成功");
						// that.page = 1;
						// that.getList();

					}
				}).catch(function(error) {
					loading.close();
					console.log("--------++++++++————————————");
					console.log(error);
				});
			},
			yanDialogClose() {
				this.yanForm = {};
			},
			isDelOrderItem() {

				let that = this;
				that.$axios({
					method: 'post',
					url: '/fang/deleteShenFen',
					data: {
						id: that.delId,
					}
				}).then(function(respose) {
					if (respose.code == "1") {
						that.dialogVisible = false;
						that.page = 1;
						that.getList();
					}
					console.log(respose);
				}).catch(function(error) {

				})
			},

			deleteOrderItem(e) {

				this.delId = e.id;
				this.dialogVisible = true;

			},
			tzDialogClose() {

			},
			lookClick(e) {
				this.areaId = e.id.toString();
				// this.deviceDialog = true;
				this.drawer = true;
			},
			showBtn(e) {
				if (e == 1) {
					this.page = 1;
					this.getList();
				} else if (e == 2) {
					this.yanDialog = true;
				} else {
					this.yanDialog = true;
				}
			},
			handleSizeChange(e) {

			},
			handleCurrentChange(e) {
				this.page = e;
				this.getList();
			},
			getList() {
				let that = this;
				that.$axios({
					method: 'post',
					url: '/camer/getCameraList',
					data: {
						channelName: that.deviceName,
						page: that.page,
						rows: that.position,
					}
				}).then(function(respose) {
					if (respose.code == "1") {

						let content = respose.content;
						let list = content.list;

						that.tableData = list;
						that.total = content.total_count;
					}

					console.log(respose);
				}).catch(function(error) {

				})
			},
			deviceDialogClose() {
				this.deviceDialog = false;
				console.log("vvvvvvvvvvvvvvvv")
			},
			yanSubmit(formName) {
				let that = this;
				this.$refs[formName].validate((valid) => {
					if (valid) {
						let yan = that.yanForm.yanpass;
						if (yan == "123456") {
							that.getDeviceList();
						} else {
							that.$message("密码不对……");
						}


					} else {
						console.log('error submit!!');
						return false;
					}
				});
			},
			getDeviceList() {
				let that = this;
				const loading = this.$loading({
					lock: true,
					text: '正在获取…',
					spinner: 'el-icon-loading',
					background: 'rgba(0, 0, 0, 0.7)'
				});
				that.$axios({
					method: 'post',
					url: '/camer/getDeviceList'
				}).then(function(respose) {
					loading.close();
					if (respose.code == "1") {
						that.yanDialog = false;
						that.page = 1;
						that.getList();
					}

				}).catch(function(error) {
					loading.close();
					console.log("--------++++++++————————————");
					console.log(error);
				});
			},
			onSubmit(formName) {
				let that = this;
				this.$refs[formName].validate((valid) => {
					if (valid) {
						const loading = this.$loading({
							lock: true,
							text: '正在提交…',
							spinner: 'el-icon-loading',
							background: 'rgba(0, 0, 0, 0.7)'
						});
						that.$axios({
							method: 'post',
							url: '/fang/addNShenFen',
							data: that.form,

						}).then(function(respose) {
							loading.close();
							if (respose.code == "1") {
								that.tzDialogFormVisible = false;
								that.page = 1;
								that.getList();
							}

						}).catch(function(error) {
							loading.close();
							console.log("--------++++++++————————————");
							console.log(error);
						});
					} else {
						console.log('error submit!!');
						return false;
					}
				});
			},
			update(e) {

				let file = e.target.files[0];
				console.log(file);
				var that = this;
				const loading = this.$loading({
					lock: true,
					text: '正在上传',
					spinner: 'el-icon-loading',
					background: 'rgba(0, 0, 0, 0.7)'
				});
				that.$axios({
					method: 'post',
					url: '/yinhang/uploadExcel',
					headers: {
						'Content-Type': 'multipart/form-data'
					},
					data: {
						file: file
					}
				}).then(function(respose) {
					loading.close();
					console.log(respose);
					console.log(respose.code);
					document.getElementById("file-excel").value = "";
					if (respose.code == 1) {
						that.$message(respose.object);
						that.page = 1;
						that.getList();
					}
				}).catch(function(error) {
					document.getElementById("file-excel").value = "";
					loading.close();
				});

			},
			uploadImg(index) {
				console.log(index);
				this.$refs.file2.click(index);
			}
		},
		mounted() {
			this.getList();

		}
	}
</script>

<style>
	.file {
		display: none;
	}
</style>
